import { useTranslations } from "next-intl";
import {
  useReloadCustomizableCloset,
  useCurrentClosetBackToRTC,
} from "@hooks/use-customizable-closet";
import { useCloseDrawer } from "@hooks/use-drawer";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import Button from "@components/core/Button";
import ClosetItemsList from "@components/core/ClosetItemsList";
import ClosetValidationCompleteSubHeader from "../DrawerClosetRTC/ClosetValidationCompleteSubHeader";

function DrawerClosetRTPValidationComplete({ setStep }) {
  const t = useTranslations("common");

  const currentCloset = useCustomizableCloset();
  const closeDrawer = useCloseDrawer();
  const currentClosetBackToRTC = useCurrentClosetBackToRTC();
  const reloadCustomizableCloset = useReloadCustomizableCloset();

  async function backToRTC() {
    try {
      await currentClosetBackToRTC();
    } catch (error) {
      closeDrawer();
      reloadCustomizableCloset();
    }
  }

  return (
    <div>
      <ClosetValidationCompleteSubHeader setStep={setStep} />

      <div className="m-2">
        <ClosetItemsList closet={currentCloset} />
      </div>
      <div className="d-flex flex-column align-items-center bg-white pt-3 px-4 text-center">
        <p className="px-2 mb-2">
          {currentCloset?.stuck_in_ready_to_pack
            ? t("drawer.modal_closet_rtp.stuck_in_rtp")
            : t("drawer.modal_closet_rtp.any_doubt")}
        </p>
        <Button
          variant="link-primary"
          className="mx-auto font-weight-medium no-underline mb-4"
          onClick={backToRTC}
        >
          {t("drawer.modal_closet_rtp.change_my_selection")}
        </Button>
      </div>
    </div>
  );
}

export default DrawerClosetRTPValidationComplete;
